import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import EmptyData from "go-core/components/EmptyData";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { PartnerProvisionApi } from "../../../../../../../../../services/Api/Partner/partnerTypes";

interface Props {
	provisions: PartnerProvisionApi[];
}

const PartnerProvisionsCard = ({ provisions }: Props) => {
	const { t } = useTranslation("admin");

	if (provisions.length === 0) {
		return (
			<Card>
				<Card.Body>
					<EmptyData title={t("modules.partner.field.no_provisions.title")} />
				</Card.Body>
			</Card>
		);
	}

	return (
		<Card>
			<Card.Body>
				<h5>{t("modules.partner.field.permission.title")}</h5>
				<table className={"table table-preview"}>
					<thead>
						<tr>
							<th>{t("modules.partner.field.value.title")}</th>
							<th>{t("common.word.billed_period")}</th>
							<th>Reference id</th>
						</tr>
					</thead>
					<tbody>
						{provisions.map((provision, index) => {
							return (
								<tr key={provision.id}>
									<td>
										{provision.type === "PERCENT" ? (
											<>{provision.provision} %</>
										) : (
											<>
												{FormatMoney({
													amount: provision.provision,
													currency: "PLN",
												})}
											</>
										)}
									</td>
									<td>{provision.billing_period}</td>
									<td>{provision.reference_id}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</Card.Body>
		</Card>
	);
};
export default PartnerProvisionsCard;
